import { React, useContext, useEffect } from "react";
import axios from "axios";

//Context
import MyContext from "../context/MyContext";

function Footer() {
  const {
    dev,

    //Authentication
    headers,
    setHeaders,
    requestAuthentication,
    setRequestAuthentication,
  } = useContext(MyContext);
  const year = new Date().getFullYear();

  //Authenticate
  useEffect(() => {
    if (!headers && !requestAuthentication) {
      setRequestAuthentication(true);
      axios
        .get(
          dev ? "http://localhost:5000/api/authenticate" : "api/authenticate"
        )
        .then(
          (response) => {
            if (response.status === 200) {
              setHeaders({
                Authorization: "Bearer " + response.data.token,
                "Content-Type": "application/json",
              });
              console.log("Laminin Response: " + response.status);
            } else {
              console.log("Laminin Response: " + response.status);
            }
          },
          (error) => {
            console.log("Laminin Response Error: " + error);
          }
        );
    }
  }, [
    dev,
    headers,
    setHeaders,
    requestAuthentication,
    setRequestAuthentication,
  ]);

  return (
    <footer>
      <p className="center">Laminin Copyright ⓒ {year}</p>
    </footer>
  );
}

export default Footer;
